class NSS5050 extends HTMLElement {

  constructor() {
    super();

    this.debug = false;

    this.swiper;
  }

  connectedCallback() {
    if (this.debug) console.log("[NSS][50/50] Connected.");

    const carouselEl = this.querySelector(`.swiper`);

    this.swiper = new Swiper(carouselEl, {
      autoHeight: true,
      grabCursor: true,
      slidesPerView: 1.3,
      spaceBetween: 20,

      breakpoints: {
        414: {
          slidesPerView: 1.8,
        },
        750: {
          slidesPerView: 2.8,
        },
        990: {
          slidesPerView: 4,
        },
      },

      a11y: {
        enabled: true,
      },
    
      navigation: {
        prevEl: '.nss-5050-prev',
        nextEl: '.nss-5050-next',
      },
    
      scrollbar: {
        el: '.nss-5050-scrollbar',
        draggable: true,
      },
    });

  }
}

let elementName = `nss-5050`;
if (typeof customElements.get(elementName) === `undefined`) {
  customElements.define(elementName, NSS5050);
} else {
  console.warn(`[NSS] Element '${elementName}' already defined.`)
}